import {Directive, Injector, OnDestroy, OnInit} from '@angular/core';
import {BasePageComponent} from "./base-page.component";

@Directive()
// tslint:disable-next-line:directive-class-suffix
export abstract class BasePageModal extends BasePageComponent implements OnInit, OnDestroy {
  activeModal: string;

  protected constructor(injector: Injector) {
    super(injector);
    // modal service
    this.modalService.modal.subscribe((id) => {
      this.activeModal = id;
    });
  }

  closeModal(modalName: string) {
    this.modalService.hide(modalName);
  }
}
